export const ruleCategory = 'ruleCategory';

/**
 * Canonical per-type metadata.
 *
 * `color` values MUST match CategoryColorResolver::UI_MAP in the PHP backend.
 * Keep them in sync.
 *
 * MSAC (31 Oct 2026): a scale of contact — Б-1 … Б-4 cool to hot, red for
 * Б-4 alone, Б-7 purple, the demonstrations Б-5 yellow and Б-6 green.
 */
export const ruleCategoryType = {
  kata: {
    text:  'Kata',
    color: 'rgb(67, 160, 71)',      // green — same as B6
    type:  ruleCategory,
  },
  'kata-all-style': {
    text:  'Kata All Style',
    color: 'rgb(255, 179, 0)',      // yellow — same as B1
    type:  ruleCategory,
  },
  kumite: {
    text:  'Kumite',
    color: 'rgb(0, 172, 193)',      // blue
    type:  ruleCategory,
  },
  fukugo: {
    text:  'Fuku-Go',
    color: 'rgb(229, 57, 53)',      // red — same as B4
    type:  ruleCategory,
  },
  b1: {
    text:  'B1',
    color: 'rgb(66, 165, 245)',      // blue — light contact
    type:  ruleCategory,
  },
  b2: {
    text:  'B2',
    color: 'rgb(38, 166, 154)',      // teal — controlled contact
    type:  ruleCategory,
  },
  b3: {
    text:  'B3',
    color: 'rgb(251, 140, 0)',      // orange — full contact
    type:  ruleCategory,
  },
  b4: {
    text:  'B4',
    color: 'rgb(229, 57, 53)',      // red — full contact, knees and elbows
    type:  ruleCategory,
  },
  b5: {
    text:  'B5',
    color: 'rgb(253, 216, 53)',      // yellow — pair demonstration
    type:  ruleCategory,
  },
  b6: {
    text:  'B6',
    color: 'rgb(124, 179, 66)',      // green — forms
    type:  ruleCategory,
  },
  // Б-7 — the organiser's version, fought under Б-2's rules but given its own
  // hue so a schedule never reads one as the other. Not in the ВСБ rulebook;
  // see docs/operations/competition-decisions-log.md.
  b7: {
    text:  'B7',
    color: 'rgb(142, 36, 170)',      // purple — Б-7, a hue of its own
    type:  ruleCategory,
  },
  'contact-shobu': {
    text:  'Contact-Shobu',
    color: 'rgb(130, 119, 23)',
    type:  ruleCategory,
  },
  fantom: {
    text:  'Fantom',
    color: 'rgb(57, 73, 171)',
    type:  ruleCategory,
  },
};
